import { config } from "config"

const routes = {
    signin: () => `${config.baseApiUrl()}/users/signin`,
    tokenRefresh: () => `${config.baseApiUrl()}/auth/token/refresh`,
    userInfo: () => `${config.baseApiUrl()}/users/me`,
    userProfileTypes: () => `${config.baseApiUrl()}/user-profile-types`,
    setDefaultProfile: () => `${config.baseApiUrl()}/users/profile`,
    wspoll: () => `${config.wshost()}/v1/ws`,
    checkAuth: () => `${config.baseApiUrl()}/auth/token/check`,
    objectFlow: (type: string) => `${config.baseApiUrl()}/objects/graph?filter={"industry_type":"${type}"}`,
    deviceDataFlow: (group: string, last_data: boolean, value_date: Date | undefined) => `${config.baseApiUrl()}/objects/data/${group}/current+session?options={"full_value": "true", "last": "${last_data}", "value_date": "${value_date ? value_date.toUTCString() : ""}"}`,
    objectMap: (type: string) => `${config.baseApiUrl()}/objects/map?filter={"industry_type":"${type}"}`,
    deviceChartData: (id: string, archive: string, limit: number, date_start: Date | null, date_end: Date | null) => `${config.baseApiUrl()}/devices/${id}/chart-data?archive=${archive}&limit=${limit}&date_start=${date_start ? date_start.toUTCString() : ""}&date_end=${date_end ? date_end.toUTCString() : ""}`,
    
    // Audit routes
    auditHistory: (tableName: string, recordId: string) => `${config.baseApiUrl()}/audit/${tableName}/${recordId}/history`,
    auditFieldHistory: (tableName: string, recordId: string, fieldName: string) => `${config.baseApiUrl()}/audit/${tableName}/${recordId}/field/${fieldName}/history`,
    auditRecentChanges: () => `${config.baseApiUrl()}/audit/recent`,
    auditStatistics: () => `${config.baseApiUrl()}/audit/statistics`,
    auditRestore: (tableName: string, recordId: string) => `${config.baseApiUrl()}/audit/${tableName}/${recordId}/restore`,

    // Dashboard routes
    dashboardStatistics: () => `${config.baseApiUrl()}/dashboards/statistics`,
    dashboards: () => `${config.baseApiUrl()}/dashboards`,
    dashboard: (id: string) => `${config.baseApiUrl()}/dashboards/${id}`,

    // Dashboard Management routes
    dashboardManagement: () => `${config.baseApiUrl()}/dashboards/management`,
    dashboardManagementById: (id: string) => `${config.baseApiUrl()}/dashboards/management/${id}`,
    dashboardFromTemplate: () => `${config.baseApiUrl()}/dashboards/management/from-template`,
    dashboardTemplates: () => `${config.baseApiUrl()}/dashboards/management/templates`,
    dashboardWidgetPositions: (id: string) => `${config.baseApiUrl()}/dashboards/management/${id}/widgets/positions`,

    // Widget Management routes
    widgets: () => `${config.baseApiUrl()}/dashboards/widgets`,
    widgetById: (id: string) => `${config.baseApiUrl()}/dashboards/widgets/${id}`,
    widgetTypes: () => `${config.baseApiUrl()}/dashboards/widgets/types`,
    widgetValidate: () => `${config.baseApiUrl()}/dashboards/widgets/validate`,
    widgetTypeSchema: (type: string) => `${config.baseApiUrl()}/dashboards/widgets/types/${type}/schema`,

    // Dashboard Data Source routes
    dashboardDataObjects: () => `${config.baseApiUrl()}/objects`,
    dashboardDataDevices: () => `${config.baseApiUrl()}/devices`,
    dashboardDataArchiveTypes: () => `${config.baseApiUrl()}/archive-types`,
    dashboardDataParams: () => `${config.baseApiUrl()}/params`,
    dashboardDataDeviceParams: (deviceId: string, archiveTypeId?: string) => {
        const base = `${config.baseApiUrl()}/devices/${deviceId}/params`;
        return archiveTypeId ? `${base}?archive_type_id=${archiveTypeId}` : base;
    },
    dashboardDataHistorical: () => `${config.baseApiUrl()}/dashboards/data/historical`,
}

export default routes